import { BgColors } from "@/libraries/design/components/link/src/link";
import { usePaidJswProductTourContext } from "@/templates/paid-landing/src/hooks/use-paid-jsw-product-tour-context";

import { SignInProviders } from "./components";
import { SignupAnalyticsContext, useSignupFormContext } from "./hooks";
import { DefaultSignupForm, PaidEmailForm } from "./variants";

type EmailFormProps = {
    readonly emailFormOnly?: boolean;
    readonly animatedSocialBanner?: boolean;
    readonly hasRebrandedSignupFormStyles?: boolean;
    readonly bgColor?: BgColors;
    readonly customSignInProviders?: SignInProviders;
    readonly hideLegalText?: boolean;
};

export const SignupForm = ({
    emailFormOnly,
    animatedSocialBanner,
    hasRebrandedSignupFormStyles,
    bgColor = "bgWhite",
    customSignInProviders,
    hideLegalText
}: EmailFormProps) => {
    const { productName } = useSignupFormContext();

    const { isAnimatedHero } = usePaidJswProductTourContext();

    let variant = <DefaultSignupForm />;

    if (isAnimatedHero || emailFormOnly) {
        variant = (
            <PaidEmailForm
                animatedSocialBanner={animatedSocialBanner}
                hasRebrandedSignupFormStyles={hasRebrandedSignupFormStyles}
                bgColor={bgColor}
                customSignInProviders={customSignInProviders}
                hideLegalText={hideLegalText}
            />
        );
    }

    return (
        <SignupAnalyticsContext productName={productName}>
            {variant}
        </SignupAnalyticsContext>
    );
};
